module.exports = __webpack_public_path__ + "img/icon-3.591e414.png";